import {
  Icon3DLine,
  IconBinocularsGray,
  IconBuildings,
  IconCctvLine,
  IconChainLink,
  IconClockGray,
  IconCloud,
  IconGlobal,
  IconRoom,
  IconRoute,
  IconRulerGray,
  IconShare,
  IconShareGray,
  IconTagGray,
  IconTvocGray,
  IconZoneGray,
} from '@assets/images/icon';
import { rtlsSystem } from '@assets/images/solution';

import image1 from '@src/assets/images/digitaltwin/image/image1.avif';
import image2 from '@src/assets/images/digitaltwin/image/image2.avif';

import gis from '@src/assets/images/digitaltwin/video/gis.mp4';
import weather from '@src/assets/images/digitaltwin/video/weather.mp4';
import buildings from '@src/assets/images/digitaltwin/video/buildings.mp4';
import tracking from '@src/assets/images/digitaltwin/video/tracking.mp4';
import traffic from '@src/assets/images/digitaltwin/video/traffic.mp4';
import airplane from '@src/assets/images/digitaltwin/video/airplane.mp4';
import cctv from '@src/assets/images/digitaltwin/video/cctv.mp4';

export default {
  type: '城市解决方案',

  banner: {
    title: '通过数字孪生高效管理城市基础设施',
    desc: '通过数字孪生技术实时监控城市基础设施的状态和运营状况，高效管理，提升运营的稳定性与效率。',
  },

  video: {
    title: '通过数字孪生技术一目了然掌握城市所有基础设施状态',
    desc: '利用数字孪生技术实时整合和可视化城市关键基础设施的状态与运营数据，实现系统化、高效管理。',
    // play: mainVideo,
    image: image1,
  },

  func: [
    {
      theme: '通过数字孪生实时查看和管理城市基础设施状态',
      title: '实时3D可视化',
      desc: '以精确的3D模型呈现城市建筑及内部设施，直观查看实时信息，快速把握设施运营状态，实现高效运营。',
      sub1: '高精度',
      icon1: IconRulerGray,
      sub2: '实时状态掌握',
      icon2: IconClockGray,
      video: gis,
    },
    {
      title: '实时气象与空气信息联动',
      desc: '实时将真实世界的天气数据（如雨、雪）与系统联动，逼真还原气象状态，提供沉浸式、精准的运营应对方案。',
      sub1: '快速数据联动',
      icon1: IconTvocGray,
      sub2: '实时位置追踪',
      icon2: IconBinocularsGray,
      video: weather,
    },
    {
      title: '实时建筑信息呈现',
      desc: '实时监控设施状态及维护计划，通过传感器数据预测设备故障与能源消耗，支持高效、环保运营管理。',
      sub1: '实时位置追踪',
      icon1: IconBinocularsGray,
      sub2: '高精度',
      icon2: IconRulerGray,
      video: buildings,
    },
    {
      title: '室内实时地图呈现',
      desc: '实时反映室内物品和人员信息，准确掌握人流动态与安全状况，支持快速运营管理与安防响应。',
      sub1: '灵活区域设定',
      icon1: IconZoneGray,
      sub2: '多区域支持',
      icon2: IconTagGray,
      video: tracking,
    },
    {
      theme: '整合城市整体移动及安全信息，支持高效运营',
      title: '实时人员及车辆移动信息管理',
      desc: '实时分析城市车辆及人员移动信息，预防交通拥堵，及时应对安全事故，助力快速、精准的城市运营。',
      sub1: '灵活区域设定',
      icon1: IconTagGray,
      sub2: '多区域支持',
      icon2: IconZoneGray,
      image: image2,
    },
    {
      title: '实时公共交通信息联动',
      desc: '提供公交、地铁等公共交通的实时运行信息，推荐最佳路线，最大限度减少交通拥堵，大幅提升城市交通效率。',
      sub1: '高精度',
      icon1: IconZoneGray,
      sub2: '多区域支持',
      icon2: IconTagGray,
      video: traffic,
    },
    {
      title: '实时航班信息联动',
      desc: '实时联动航班信息，及时推送航班延误或变动，提升出行顺畅性与运营效率。',
      sub1: '快速部署',
      icon1: IconTagGray,
      sub2: '多区域支持',
      icon2: IconTagGray,
      video: airplane,
    },
    {
      title: 'CCTV视频实时监控及管理',
      desc: '实时接入城市CCTV画面，及时发现异常迹象，快速应对犯罪预防及交通管理，有效保障城市安全。',
      sub1: '实时可视化',
      icon1: IconShareGray,
      sub2: '多区域支持',
      icon2: IconTagGray,
      video: cctv,
    },
  ],

  subfunc: {
    title: '主要功能概览',
    desc: '',

    data: [
      {
        icon: Icon3DLine,
        title: '实时3D可视化',
        desc: '支持城市设施的实时3D渲染与监控',
      },
      {
        icon: IconCloud,
        title: '实时气象信息联动',
        desc: '实时将真实天气数据与系统联动',
      },
      {
        icon: IconBuildings,
        title: '建筑信息查看',
        desc: '实时监控建筑设施状态及能源使用',
      },
      {
        icon: IconRoom,
        title: '室内实时地图',
        desc: '实时提供室内物品及人员位置地图',
      },
      {
        icon: IconRoute,
        title: '人员及车辆移动分析',
        desc: '实时分析车辆与人员移动数据并应对',
      },
      {
        icon: IconChainLink,
        title: '公共交通信息联动',
        desc: '提供公交、地铁等实时位置信息',
      },
      {
        icon: IconShare,
        title: '实时航班信息联动',
        desc: '实时将航班运行信息接入系统',
      },
      {
        icon: IconCctvLine,
        title: 'CCTV实时监控',
        desc: '实时分析CCTV画面，保障城市安全',
      },
      {
        icon: IconGlobal,
        title: '地理信息平台联动',
        desc: '与GIS数据联动，高效管理空间信息',
      },
      {
        icon: IconChainLink,
        title: '外部系统API联动',
        desc: '灵活整合多系统数据',
      },
    ],
  },

  system: {
    title: '系统结构',
    img: rtlsSystem,
  },

  productTitle: '产品组合',
  product: [{ tag: 'workerPackage' }, { tag: 'assetPackage' }],

  contents: [{ data: 'constructionAsset' }, { data: 'constructionEquipment' }, { data: 'blogRTLS' }, { data: 'blogMedical' }],
};
